import React, { useEffect, useCallback, useState} from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import {connect} from 'react-redux';

const FMFeedback = (props) => { 
    return (
        <div>
          <EffectParameterSlider
            name={'Feedback'}
            sequencerEngine={props.sequencerEngine}
            lfoEnabled={true}
            parameter={props.oscillator.feedbackParameter}
            onParameterChanged={() => []}
            isParameter={true}
            min={0}
            max={2}
            step={0.01}
          />
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FMFeedback);
